// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"69c9c24d","lsc":"2e7467ff","others":"aa686256"}[chunkId] + ".chunk.js";
};